import { useQuery } from "@tanstack/react-query";
import { apiGetRequest, getUserSession } from "utils/api";

interface LoanType {
  id: string;
  title: string;
  description: string;
}

interface FormattedLoanType {
  label: string;
  value: string;
  description: string;
}

const fetchLoanTypes = async (): Promise<FormattedLoanType[]> => {
  const session = await getUserSession();

  if (!session) {
    return [];
  }

  const { loan_types } = await apiGetRequest("/supabase/loan_types/select");
  return loan_types?.map((loan_type: LoanType) => ({
    label: loan_type.title,
    value: loan_type.id,
    description: loan_type.description,
  }));
};
export const useLoanTypes = () => {
  const {
    data: loanTypes = [],
    isLoading: loading,
    error,
  } = useQuery({
    queryKey: ["loanTypes"],
    queryFn: fetchLoanTypes,
    gcTime: 5 * 60 * 1000, // 5 minutes
    staleTime: 60 * 1000, // 1 minute
  });

  return { loanTypes, loading, error };
};
